export default "__VITE_ASSET__TdcPJE1p__"